// import React, { useState, useEffect } from "react";
// import { Layout, Menu, Input, Select, Drawer, Button } from "antd";
// import { useSelector, useDispatch } from "react-redux";
// import { fetchSideBarAsanas } from "../Redux/Action/SidebarAsanaAction";
// import { animatedMenuStyles } from "../Config";
// import { GrYoga } from "react-icons/gr";
// import { useNavigate, useLocation } from "react-router-dom";
// import { motion } from "framer-motion";

// const { Sider } = Layout;
// const { Search } = Input;
// const { Option } = Select;

// const makeSlug = (text = "") =>
//   text
//     .toLowerCase()
//     .trim()
//     .replace(/[^a-z0-9\s-]/g, "")
//     .replace(/\s+/g, "-");

// const AppSlider = () => {
//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedLevel, setSelectedLevel] = useState("all");
//   const [selectedType, setSelectedType] = useState("all");
//   const [mobile, setMobile] = useState(false);
//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const [hovered, setHovered] = useState(false);

//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const location = useLocation();

//   const isHome = location.pathname === "/" || location.pathname === "/asanas";
//   const { sideAsanas } = useSelector((state) => state.sideBarAsana);

//   useEffect(() => {
//     dispatch(
//       fetchSideBarAsanas({
//         name: "",
//         level: selectedLevel === "all" ? "" : selectedLevel,
//         poseType: selectedType === "all" ? "" : selectedType,
//       }),
//     );
//   }, [dispatch, selectedLevel, selectedType]);

//   useEffect(() => {
//     const resize = () => setMobile(window.innerWidth < 900);
//     resize();
//     window.addEventListener("resize", resize);
//     return () => window.removeEventListener("resize", resize);
//   }, []);

//   const sidebarWidth = isHome ? 250 : hovered ? 250 : 90;

//   const menuItems = (sideAsanas ?? [])
//   .filter((i) => {
//     if (!searchTerm.trim()) return true;
//     const q = searchTerm.toLowerCase();
//     return (
//       i.name?.toLowerCase().includes(q) ||
//       i.english?.toLowerCase().includes(q) ||
//       i.englishName?.toLowerCase().includes(q) ||
//       i.sanskritName?.toLowerCase().includes(q)
//     );
//   })
//   .map((i) => ({
//     key: `/asanas/${i._id}/${makeSlug(i.name)}`,
//     icon: <GrYoga />,
//     label: i.name,
//   }));

//   const menuContent = (
//     <>
//       <style>{animatedMenuStyles}</style>

//       <div style={{ padding: 10 }}>
//         <Search
//           placeholder="Search asana..."
//           allowClear
//           onChange={(e) => setSearchTerm(e.target.value)}
//           style={{ marginBottom: 10 }}
//         />

//         <Select
//           value={selectedLevel}
//           onChange={setSelectedLevel}
//           style={{ width: "100%", marginBottom: 10 }}
//         >
//           <Option value="all">All Levels</Option>
//           <Option value="beginner">Beginner</Option>
//           <Option value="intermediate">Intermediate</Option>
//           <Option value="advanced">Advanced</Option>
//         </Select>

//         <Select
//           value={selectedType}
//           onChange={setSelectedType}
//           style={{ width: "100%", marginBottom: 10 }}
//         >
//           <Option value="all">All Pose Types</Option>
//           <Option value="standing">Standing</Option>
//           <Option value="seated">Seated</Option>
//           <Option value="forward bend">Forward Bend</Option>
//           <Option value="twist">Twist</Option>  
//           <Option value="binding">binding</Option>
//           <Option value="backbend">Backbend</Option>
//           <Option value="balance">Balance</Option>
//           <Option value="inversion">Inversion</Option>
//           <Option value="side bend">side bend</Option>
//           <Option value="arm balances">Arm Balances</Option>
//           <Option value="core">Core</Option>
//           <Option value="Quadruped Poses">Quadruped Poses</Option>
//           <Option value="Hip Openers">Hip Openers</Option>
//           <Option value="knee stand">knee stand</Option>
//           <Option value="supine">supine</Option>
//           <Option value="prone">prone</Option>

//         </Select>

//         <div style={{ height: "70vh", overflowY: "auto" }}>
//           <Menu
//             mode="inline"
//             items={menuItems}
//             className="yoga-menu"
//             onClick={({ key }) => {
//               navigate(key);
//               setDrawerOpen(false);
//             }}
//           />
//         </div>
//       </div>
//     </>
//   );

//   /* MOBILE */
//   if (mobile) {
//     return (
//       <>
//         <Button
//           type="primary"
//           style={{ position: "fixed", left: 10, top: 70, zIndex: 1000 }}
//           onClick={() => setDrawerOpen(true)}
//         >
//           ☰ Menu
//         </Button>

//         <Drawer
//           title="Yoga Poses"
//           placement="left"
//           open={drawerOpen}
//           onClose={() => setDrawerOpen(false)}
//           width={260}
//         >
//           {menuContent}
//         </Drawer>
//       </>
//     );
//   }

//   /* DESKTOP */
//   return (
//     <motion.div
//       onMouseEnter={() => setHovered(true)}
//       onMouseLeave={() => setHovered(false)}
//       animate={{ width: sidebarWidth }}
//       transition={{ type: "spring", stiffness: 260, damping: 30 }}
//       style={{
//         position: "sticky",
//         top: 64,
//         height: "100vh",
//         background:
//           "linear-gradient(to right, rgb(255, 215, 0), rgb(255, 165, 0))",
//         overflow: "hidden",
//       }}
//       className={`app-slider ${isHome ? "home-open" : "collapsed"}`}
//     >
//       <Sider width="100%" style={{ background: "transparent" }}>
//         <motion.div
//           initial={false}
//           animate={{
//             opacity: isHome || hovered ? 1 : 20,
//             x: isHome || hovered ? 0 : -0,
//           }}
//           transition={{ duration: 0.25, ease: "easeOut" }}
//           style={{ height: "100%" }}
//         >
//           {menuContent}
//         </motion.div>
//       </Sider>
//     </motion.div>
//   );
// };

// export default AppSlider;


import React, { useState, useEffect } from "react";
import { Layout, Menu, Input, Select, Drawer, Button } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { fetchSideBarAsanas } from "../Redux/Action/SidebarAsanaAction";
import { animatedMenuStyles } from "../Config";
import { GrYoga } from "react-icons/gr";
import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";

const { Sider } = Layout;
const { Search } = Input;
const { Option } = Select;

// ✅ Same slug generator used everywhere — must match backend slugify output
const makeSlug = (text = "") =>
  text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-");

const AppSlider = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedLevel, setSelectedLevel] = useState("all");
  const [selectedType, setSelectedType] = useState("all");
  const [mobile, setMobile] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [hovered, setHovered] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const isHome = location.pathname === "/" || location.pathname === "/asanas";
  const { sideAsanas } = useSelector((state) => state.sideBarAsana);

  useEffect(() => {
    dispatch(
      fetchSideBarAsanas({
        name: "",
        level: selectedLevel === "all" ? "" : selectedLevel,
        poseType: selectedType === "all" ? "" : selectedType,
      }),
    );
  }, [dispatch, selectedLevel, selectedType]);

  useEffect(() => {
    const resize = () => setMobile(window.innerWidth < 900);
    resize();
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  const sidebarWidth = isHome ? 250 : hovered ? 250 : 90;

  const menuItems = (sideAsanas ?? [])
    .filter((i) => {
      if (!searchTerm.trim()) return true;
      const q = searchTerm.toLowerCase();
      return (
        i.name?.toLowerCase().includes(q) ||
        i.english?.toLowerCase().includes(q) ||
        i.englishName?.toLowerCase().includes(q) ||
        i.sanskritName?.toLowerCase().includes(q)
      );
    })
    .map((i) => ({
      // ✅ FIXED: use slug from DB if available, otherwise generate from name
      // Before: `/asanas/${i._id}/${makeSlug(i.name)}`  ← MongoDB _id in URL
      // After:  `/asanas/${i.slug || makeSlug(i.name)}` ← clean slug only
      key: `/asanas/${i.slug || makeSlug(i.name)}`,
      icon: <GrYoga />,
      label: i.name,
    }));

  const menuContent = (
    <>
      <style>{animatedMenuStyles}</style>

      <div style={{ padding: 10 }}>
        <Search
          placeholder="Search asana..."
          allowClear
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{ marginBottom: 10 }}
        />

        <Select
          value={selectedLevel}
          onChange={setSelectedLevel}
          style={{ width: "100%", marginBottom: 10 }}
        >
          <Option value="all">All Levels</Option>
          <Option value="beginner">Beginner</Option>
          <Option value="intermediate">Intermediate</Option>
          <Option value="advanced">Advanced</Option>
        </Select>

        <Select
          value={selectedType}
          onChange={setSelectedType}
          style={{ width: "100%", marginBottom: 10 }}
        >
          <Option value="all">All Pose Types</Option>
          <Option value="standing">Standing</Option>
          <Option value="seated">Seated</Option>
          <Option value="forward bend">Forward Bend</Option>
          <Option value="twist">Twist</Option>
          <Option value="binding">binding</Option>
          <Option value="backbend">Backbend</Option>
          <Option value="balance">Balance</Option>
          <Option value="inversion">Inversion</Option>
          <Option value="side bend">side bend</Option>
          <Option value="arm balances">Arm Balances</Option>
          <Option value="core">Core</Option>
          <Option value="Quadruped Poses">Quadruped Poses</Option>
          <Option value="Hip Openers">Hip Openers</Option>
          <Option value="knee stand">knee stand</Option>
          <Option value="supine">supine</Option>
          <Option value="prone">prone</Option>
        </Select>

        <div style={{ height: "70vh", overflowY: "auto" }}>
          <Menu
            mode="inline"
            items={menuItems}
            className="yoga-menu"
            onClick={({ key }) => {
              navigate(key);
              setDrawerOpen(false);
            }}
          />
        </div>
      </div>
    </>
  );

  /* MOBILE */
  if (mobile) {
    return (
      <>
        <Button
          type="primary"
          style={{ position: "fixed", left: 10, top: 70, zIndex: 1000 }}
          onClick={() => setDrawerOpen(true)}
        >
          ☰ Menu
        </Button>

        <Drawer
          title="Yoga Poses"
          placement="left"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          width={260}
        >
          {menuContent}
        </Drawer>
      </>
    );
  }

  /* DESKTOP */
  return (
    <motion.div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      animate={{ width: sidebarWidth }}
      transition={{ type: "spring", stiffness: 260, damping: 30 }}
      style={{
        position: "sticky",
        top: 64,
        height: "100vh",
        background:
          "linear-gradient(to right, rgb(255, 215, 0), rgb(255, 165, 0))",
        overflow: "hidden",
      }}
      className={`app-slider ${isHome ? "home-open" : "collapsed"}`}
    >
      <Sider width="100%" style={{ background: "transparent" }}>
        <motion.div
          initial={false}
          animate={{
            opacity: isHome || hovered ? 1 : 20,
            x: isHome || hovered ? 0 : -0,
          }}
          transition={{ duration: 0.25, ease: "easeOut" }}
          style={{ height: "100%" }}
        >
          {menuContent}
        </motion.div>
      </Sider>
    </motion.div>
  );
};

export default AppSlider;